var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loader"},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"spinner"}),(_vm.message)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }